import { Component, Input } from '@angular/core';
import { AuthMethodsService } from '../../auth-methods/auth-methods.service';
import { TemplateProps } from './auth-template.model';

@Component({
  selector: 'app-auth-template',
  templateUrl: './auth-template.component.html',
  styleUrls: ['./auth-template.component.scss'],
})
export class AuthTemplateComponent {

  @Input() title?: string;

  private _templateProps: TemplateProps = {
    privacyPolicy: 'Privacy Policy',
  };
  get templateProps(): TemplateProps {
    return this._templateProps;
  }
  @Input() set templateProps(value: TemplateProps) {
    this._templateProps = { ...this.templateProps, ...value };
  }

  constructor(readonly authMethodsService: AuthMethodsService) {
    this.authMethodsService.translations?.subscribe(translations => {
      this.templateProps = { ...this.templateProps, ...translations.authTemplate || {} };
    });
  }
}
